import { action, makeObservable, observable } from 'mobx';
import { RootStore } from 'store/rootStore';

/**
 * @DEPRECATED Do not use this store; instead, implement a modal delegate in your existing page store.
 * //TODO Remove store and its dependencies
 */
export default class ExitModalStore {
  rootStore: RootStore;
  showExitModal = false;

  openModal(): void {
    this.showExitModal = true;
  }

  closeModal(): void {
    this.showExitModal = false;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      showExitModal: observable,
      openModal: action.bound,
      closeModal: action.bound,
    });
  }
}
